/**
 * Created by lihanying on 2017/7/10.
 */
import React from 'react'
import {Route} from 'react-router-dom'
import ClubUsers from '../../ClubUsers'
import ClubList from '../../ClubList'
import ClubAdd from '../../ClubAdd'
import ClubEmployee from '../../ClubEmployee'
import ClubBusiness from '../../ClubBusiness'
import ClubMember from '../../ClubMember'
import ClubMemberList from '../../ClubMemberList'
import ClubBlacklist from '../../ClubBlacklist'
import ClubTable from '../../ClubTable'
import ClubDeletedTable from '../../ClubDeletedTable'
import ClubProfession from '../../ClubProfession'
import ClubCommodity from '../../ClubCommodity'
import ClubCommodityType from '../../ClubCommodityType'
import ClubLevel from '../../ClubLevel'
import ClubWallet from '../../ClubWallet'
import ClubInfo from '../../ClubInfo'
import ClubStream from '../../ClubStream'
import ClubDeploy from '../../ClubDeploy'
import Homepage from '../../Homepage'
import ClubStorage from '../../ClubStorage'
import ClubMarket from '../../ClubMarket'
import ClubRepertory from '../../ClubRepertory'
import ClubExpend from '../../ClubExpend'
import ClubStandby from '../../ClubStandby'
import ClubRevenue from '../../ClubRevenue'
import ClubRevenueNew from '../../ClubRevenueNew'
import ClubShift from '../../ClubShift'
import ClubTableStatus from '../../ClubTableStatus'
import ClubCharge from '../../ClubCharge'
import ClubChargeHelp from '../../ClubChargeHelp'
import AdvertManage from '../../AdvertManage'
import CardManage from '../../CardManage'
import Consume from '../../Consume'
import CheckOutAdvManage from '../../CheckOutAdvManage'
import ToolList from '../../ToolList'
import ClubModuleManage from '../../ClubModuleManage'
import ClubEmployeeManager from '../../ClubEmployeeManager'
import ClubShiftsSetting from '../../ClubShiftsSetting'
import ClubAttendanceRecord from '../../ClubAttendanceRecord'
import ClubServiceRecord from '../../ClubServiceRecord'
import ClubSalaryStatistics from '../../ClubSalaryStatistics'
import ClubOperationLogs from '../../ClubOperationLogs'
import Merchandise from '../../purchaseSalesInventory/Merchandise'
import Categories from '../../purchaseSalesInventory/Categories'
import Stories from '../../purchaseSalesInventory/Stories'
import Statement from '../../purchaseSalesInventory/Statement'
import ExpAndStockWarning from '../../purchaseSalesInventory/ExpAndStockWarning'
import PlatformSetting from '../../PlatformSetting'
import GroupBuyingList from '../../GroupBuyingList'
import ClubPrinterManage from '../../ClubPrinterManage'
import ClubReserve from '../../ClubReserve'
import RefundDetail from '../../RefundDetail'
import ClubPlatform from "../../ClubPlatform"
import ClubCleanTableRecord from "../../ClubCleanTableRecord";
import ClubComplaintManager from "../../ClubComplaintManager"
import TableUsageStatistics from "../../TableUsageStatistics"

const Routes = (props) => {
    return (
        <div style={{height: '100%'}}>
            <Route path="/home/Homepage" component={Homepage}/>
            <Route path="/home/ClubUsers" component={ClubUsers}/>
            <Route path="/home/ClubList" component={ClubList}/>
            <Route path="/home/ClubAdd" component={ClubAdd}/>
            <Route path="/home/ClubEmployee" component={ClubEmployee}/>
            <Route exact path="/home/ClubBusiness" component={ClubBusiness}/>
            <Route path="/home/ClubMember" component={ClubMember}/>
            <Route path="/home/ClubMemberList" component={ClubMemberList}/>
            <Route path="/home/ClubBlacklist" component={ClubBlacklist}/>
            <Route path="/home/ClubTable" component={ClubTable}/>
            <Route path="/home/ClubDeletedTable" component={ClubDeletedTable}/>
            <Route path="/home/ClubProfession" component={ClubProfession}/>
            <Route path="/home/ClubCommodity" component={ClubCommodity}/>
            <Route
                exact
                path="/home/ClubCommodityType"
                component={ClubCommodityType}
            />
            <Route path="/home/ClubLevel" component={ClubLevel}/>
            <Route path="/home/ClubWallet" component={ClubWallet}/>
            <Route path="/home/ClubInfo" component={ClubInfo}/>
            <Route path="/home/ClubStream" component={ClubStream}/>
            <Route path="/home/ClubDeploy" component={ClubDeploy}/>
            <Route path="/home/ClubStorage" component={ClubStorage}/>
            <Route path="/home/ClubMarket" component={ClubMarket}/>
            <Route path="/home/ClubRepertory" component={ClubRepertory}/>
            <Route path="/home/ClubExpend" component={ClubExpend}/>
            <Route path="/home/ClubStandby" component={ClubStandby}/>
            <Route path="/home/ClubRevenue" component={ClubRevenue}/>
            <Route path="/home/ClubRevenueNew" component={ClubRevenueNew}/>
            <Route path="/home/ClubShift" component={ClubShift}/>
            <Route path="/home/ClubTableStatus" component={ClubTableStatus}/>
            <Route path="/home/ClubCharge" component={ClubCharge}/>
            <Route path="/home/ClubChargeHelp" component={ClubChargeHelp}/>
            <Route path={'/home/advertManage'} component={AdvertManage}/>
            <Route path={'/home/CardManage'} component={CardManage}/>
            <Route path={'/home/Consume'} component={Consume}/>
            <Route path={'/home/CheckOutAdvManage'} component={CheckOutAdvManage}/>
            <Route path={'/home/toolList'} component={ToolList}/>
            <Route path={'/home/ClubModuleManage'} component={ClubModuleManage}/>
            <Route path="/home/ClubEmployeeManager" component={ClubEmployeeManager}/>
            <Route path="/home/ClubShiftsSetting" component={ClubShiftsSetting}/>
            <Route
                path="/home/ClubAttendanceRecord"
                component={ClubAttendanceRecord}
            />
            <Route path={'/home/ClubServiceRecord'} component={ClubServiceRecord}/>
            <Route path={'/home/ClubCleanTableRecord'} component={ClubCleanTableRecord}/>
            <Route path={'/home/ClubOperationLogs'} component={ClubOperationLogs}/>
            <Route
                path={'/home/ClubSalaryStatistics'}
                component={ClubSalaryStatistics}
            />
            <Route
                path={'/home/purchaseSalesInventory/Merchandise'}
                component={Merchandise}
            />
            <Route
                path={'/home/purchaseSalesInventory/Categories'}
                component={Categories}
            />
            <Route
                path={'/home/purchaseSalesInventory/Stories'}
                component={Stories}
            />
            <Route
                path={'/home/purchaseSalesInventory/Statement'}
                component={Statement}
            />
            <Route
                path={'/home/purchaseSalesInventory/ExpWarning'}
                component={ExpAndStockWarning}
            />
            <Route
                path={'/home/purchaseSalesInventory/StockWarning'}
                component={ExpAndStockWarning}
            />
            <Route path={'/home/PlatformSetting'} component={PlatformSetting}/>
            <Route path={'/home/GroupBuyingList'} component={GroupBuyingList}/>
            <Route path={'/home/ClubPrinterManage'} component={ClubPrinterManage}/>
            <Route path={'/home/ClubReserve'} component={ClubReserve}/>
            <Route path={'/home/RefundDetail'} component={RefundDetail}/>
            <Route path={'/home/ClubPlatform'} component={ClubPlatform}/>
            <Route path={'/home/ClubComplaintManager'} component={ClubComplaintManager}/>
            <Route path={'/home/TableUsageStatistics'} component={TableUsageStatistics}/>
        </div>
    )
}

export default Routes



// WEBPACK FOOTER //
// ./src/containers/Home/component/routes.js